/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S9_P2Inputs */

const tr_kullanim_s9_p2 = /** @type {(inputs: Kullanim_S9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket'in kasıt ve ağır kusuru saklı kalmak kaydıyla, her halükarda toplam sorumluluk, Kullanıcı tarafından son 12 ay içinde ödenmiş olan abonelik bedelleri ile sınırlıdır.`)
};

const en_kullanim_s9_p2 = /** @type {(inputs: Kullanim_S9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save for the Company's intent and gross negligence, total liability is in any event limited to the subscription fees paid by the User within the last 12 months.`)
};

const de_kullanim_s9_p2 = /** @type {(inputs: Kullanim_S9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbehaltlich Vorsatz und grober Fahrlässigkeit des Unternehmens ist die Gesamthaftung in jedem Fall auf die vom Nutzer in den letzten 12 Monaten gezahlten Abonnemententgelte begrenzt.`)
};

const ru_kullanim_s9_p2 = /** @type {(inputs: Kullanim_S9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За исключением умысла и грубой неосторожности Компании, совокупная ответственность в любом случае ограничена суммой абонентской платы, уплаченной Пользователем за последние 12 месяцев.`)
};

/**
* | output |
* | --- |
* | "Save for the Company's intent and gross negligence, total liability is in any event limited to the subscription fees paid by the User within the last 12 months." |
*
* @param {Kullanim_S9_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s9_p2 = /** @type {((inputs?: Kullanim_S9_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S9_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s9_p2(inputs)
	if (locale === "de") return de_kullanim_s9_p2(inputs)
	if (locale === "ru") return ru_kullanim_s9_p2(inputs)
	return tr_kullanim_s9_p2(inputs)
});